import { decodeString } from "@findemdev/findem-helpers";
import {
  ProjectCompanyOption,
  ProjectCompanyOptionLabel,
} from "../../RaasClientPortal.styled";
import { CompanyLogo } from "./CompanyLogo";

interface ICompanySelectOptionContentProps {
  label: string;
  logoRef?: string;
}

export const CompanySelectOptionContent = ({
  label,
  logoRef,
}: ICompanySelectOptionContentProps) => {
  const displayLabel = decodeString(label);

  return (
    <ProjectCompanyOption>
      <CompanyLogo
        label={displayLabel}
        logoRef={logoRef?.toLowerCase().trim()}
      />
      <ProjectCompanyOptionLabel>{displayLabel}</ProjectCompanyOptionLabel>
    </ProjectCompanyOption>
  );
};
